<label [for]="id">{{placeholder}}</label>
<select [id]="id" [multiple]="multiple" [disabled]="disabled" #selectElement>
       <ng-content></ng-content>
</select>
 